import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@urc-ui/store/types';
import { DEFAULT_PAGE_SIZE } from '@urc-ui/store/constants';

interface ReportHistoryState {
  readonly pageSize: number;
  readonly isReportHistoryStale: boolean;
}

const initialState: ReportHistoryState = {
  pageSize: DEFAULT_PAGE_SIZE,
  isReportHistoryStale: false
};

export const reportHistorySlice = createSlice({
  name: 'reportHistorySlice',
  initialState,
  reducers: {
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setReportHistoryStaleness: (state, action: PayloadAction<boolean>) => {
      state.isReportHistoryStale = action.payload;
    }
  }
});

export const { setPageSize, setReportHistoryStaleness } = reportHistorySlice.actions;

export const selectPageSize = (state: RootState) => state.reportHistory.pageSize;
export const selectIsReportHistoryStale = (state: RootState) => state.reportHistory.isReportHistoryStale;

export default reportHistorySlice.reducer;
